import type { FAQItem } from "../components/faq";

// FAQ institucional da home — perguntas sobre a empresa e o produto como um
// todo, que respondem buscas de marca ("o que é a Fidexa", "Fidexa é
// confiável") e alimentam respostas de IA. Cada resposta abre com a resposta
// direta na primeira frase. Todo fato sai de
// `.claude/skills/seo/reference/fidexa-empresa.md` (fonte entre colchetes).
//
// Sem sobreposição com /cobranca-whatsapp (régua, API oficial, LGPD do envio,
// pagar pelo WhatsApp, várias lojas) nem com /crediario (migração, painel
// multi-loja, integração, segurança do crediário).
export const HOME_FAQ_ITEMS: FAQItem[] = [
  {
    // [ERP; NV; PEGN — §1 e §6]
    question: "O que é a Fidexa?",
    answer:
      "A Fidexa é uma fintech brasileira que automatiza a cobrança do crediário próprio do varejo pelo WhatsApp, usando inteligência artificial e Pix. Ela cuida do ciclo inteiro de cobrança, do lembrete antes do vencimento ao acordo de parcelamento de dívidas em atraso, e reúne a carteira de todas as lojas em um painel único.",
  },
  {
    // [ERP; NV; PEGN — §6; "recorrente" aqui é a parcela mensal do crediário,
    // não assinatura/SaaS billing]
    question: "A Fidexa é um sistema de cobrança automatizado?",
    answer:
      "Sim. A Fidexa é um sistema de cobrança automatizado via WhatsApp: a régua de cobrança envia o lembrete antes do vencimento, o aviso no dia e a cobrança do atraso sem ninguém da loja precisar disparar mensagem. Como as parcelas do crediário vencem todo mês, a cobrança é recorrente e acompanha cada cliente até o pagamento, com negociação por inteligência artificial para os inadimplentes.",
  },
  {
    // [LP /lojistas-que-vendem-no-crediario-proprio — FAQ "A Fidexa oferece crédito?"]
    question: "A Fidexa empresta dinheiro ou oferece crédito?",
    answer:
      "Não. A Fidexa não faz empréstimos, financiamentos nem oferece crédito ao consumidor. Ela automatiza a cobrança das vendas que a sua loja já fez no crediário próprio.",
  },
  {
    // [PEGN; BAG; ERP/NV — §5; faixa de 4 a 20 lojas é posicionamento do site]
    question: "Para quem é a Fidexa?",
    answer:
      "A Fidexa é feita para pequenas e médias empresas do varejo que vendem no crediário próprio, com foco em lojas de calçados e roupas. Atende desde a loja única até redes com várias unidades, e foi pensada especialmente para redes de 4 a 20 lojas que precisam centralizar a cobrança em um só lugar.",
  },
  {
    // [ERP; NV; PEGN — §6; Chats Unificados e Análise de Conversão são do site]
    question: "Quais produtos a Fidexa oferece?",
    answer:
      "A Fidexa reúne a cobrança automatizada via WhatsApp, com régua de cobrança e negociação por inteligência artificial; o chat unificado, que junta vários números de WhatsApp em um só atendimento; a análise de conversão das cobranças; a gestão de crediário; e o Fidexa Pay, que deixa o cliente pagar a parcela por Pix na própria conversa, com baixa automática para quem usa o ERP TOTVS Linx.",
  },
  {
    // [PEGN; ERP/NV; decisão do founder: "a partir de R$ 50" — §4 e §6]
    question: "Que tipo de dívida a Fidexa consegue recuperar?",
    answer:
      "A Fidexa cobra parcelas a vencer, parcelas em atraso e até dívidas já encaminhadas para órgãos de proteção ao crédito. Isso inclui dívidas pequenas, a partir de R$ 50, que a loja costumava dar como perdidas porque o custo de cobrar na Justiça seria maior que o valor devido.",
  },
  {
    // [ERP; NV; BAG; NVJ; NEWS — §4; 32,10% por decisão do founder]
    question: "Quais resultados a Fidexa já entregou?",
    answer:
      "Em menos de um ano de operação, a Fidexa recuperou R$ 39,34 milhões para 249 empresas cadastradas e envia cerca de 15 mil mensagens de cobrança por dia, segundo dados divulgados à imprensa em agosto de 2026. A taxa média de recuperação da carteira na plataforma é de 32,10%.",
  },
  {
    // [ERP; NV; BAG; PEGN; NEWS — §2 e §3]
    question: "Quem está por trás da Fidexa?",
    answer:
      "A Fidexa foi fundada em outubro de 2025 por Bruno Reis, Hudson Ribeiro e Leonardo Azevedo, que vieram de uma empresa de software de gestão para o varejo de calçados e roupas. Em 2026, André Menezes, cofundador da foodtech TiNDLE, entrou como quarto sócio. A empresa é sediada em Limeira (SP) e atingiu o breakeven operacional com capital próprio.",
  },
  {
    // [Decisões do founder: sem preço público; demonstração gratuita]
    question: "Quanto custa a Fidexa?",
    answer:
      "O valor depende do tamanho da sua operação e da quantidade de lojas. A demonstração é gratuita: um especialista da Fidexa apresenta a plataforma com a realidade da sua rede e monta uma proposta sob medida.",
  },
];
